module.exports = __webpack_public_path__ + "static/quartier_H-fbccf62592ff2df9d0b908c5290545a1.png";